import axios from 'axios'

export default class LabelService {
  public getAll() {
    return axios.get('/api/v1/labels/')
  }
}
